import {Component, Injector, OnInit} from '@angular/core';
import {CommandsService, CommandTemplateModel as CommandTemplateViewModel} from "../../../../services/commands.service";
import {BaseAdminPanelComponent} from "../../base-admin-panel/base-admin-panel.component";
import {Observable} from "rxjs";
import {CreateCommandComponent} from "../create-command/create-command.component";
import {EditCommandComponent} from "../edit-command/edit-command.component";

@Component({
    selector: '[app-commands-component]',
    templateUrl: './commands.component.html',
    styleUrls: ['./commands.component.css'],
    standalone: false
})
export class CommandsComponent extends BaseAdminPanelComponent implements OnInit {
  public term: string;
  private service: CommandsService;

  constructor(protected injector: Injector) {
    super(injector);
    this.entityName = "Command";
    this.service = injector.get(CommandsService);
  }

  protected Refresh() {
    this.service.getCommands().subscribe((res) => this.objects = res.map((command: CommandTemplateViewModel) => {
      let res = new CommandItemViewModel();
      res.init(command);
      return res;
    }))
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.service.delete(id);
  }

  public editCommand(command: CommandItemViewModel) {
    this.prepareModal(EditCommandComponent);
    this.componentRef.instance.open(command);
  }

  public openCreateModal() {
    this.prepareModal(CreateCommandComponent);
    this.componentRef.instance.open(new CommandItemViewModel());
  }
}

export class CommandItemViewModel extends CommandTemplateViewModel {
  IsChecked: boolean = false;

  public init(data: CommandTemplateViewModel) {
    this.Id = data.Id;
    this.Name = data.Name;
    this.Command = data.Command;
    this.ObjectIds = data.ObjectIds ?? [];
  }
}
